






















































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Tenant from "@/store/entities/tenant";
import AppConsts from "@/lib/appconst";
import Ref from "@/store/entities/ref";
import Address from "../../../store/entities/address";
import AddressModal from "../../components/address-modal.vue";
import _ from "lodash";

@Component({
  components: { "address-modal": AddressModal },
})
export default class EditTenant extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  tenant: Tenant = new Tenant();
  inboundModes: Ref[] = new Array<Ref>();
  addressModalShow: boolean = false;
  selectedAddress: Address = new Address();
  tenantAddress: Address = null;
  notificationTypes: [] = [];
  objectLoading: boolean = false;
  employeeIdFilter: number = 0;
  notificationTypeCodeFilter: string = "";
  employeesFilter: [] = [];

  employeeIdConfig: number = 0;
  employeeConfig: any;
  notificationTypeCodeConfig: string = "";
  notificationTypeConfig: any;
  employeesConfig: [] = [];

  listConfig: any[] = [];

  modeAddConfig: boolean = false;
  getInboundModes(re) {
    this.inboundModes = re;
  }
  getNotificationType(re) {
    re.unshift({
      id: AppConsts.allItemValue,
      name: this.L(AppConsts.All),
    });
    this.notificationTypes = re;
  }

  save() {
    (this.$refs.tenantForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (this.modeAddConfig) {
          this.tenant.createNotificationConfigs = this.listConfig;
        }
        await this.$store.dispatch({
          type: "tenant/update",
          data: this.tenant,
        });
        (this.$refs.tenantForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.tenantForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.getInfo(this.$store.state.tenant.editTenant.id);
      this.listConfig = [];
      this.modeAddConfig = false;
      this.employeeIdConfig = 0;
      this.notificationTypeCodeConfig = "";
      this.employeeIdFilter = 0;
      this.notificationTypeCodeFilter =
        _.isNil(this.notificationTypes) || this.notificationTypes.length <= 0
          ? ""
          : _.first(this.notificationTypes).id;
    }
  }

  async getInfo(id: number) {
    await this.$store
      .dispatch({
        type: "tenant/getDetail",
        data: {
          id,
        },
      })
      .then((res) => {
        this.tenant = res;
        this.selectedAddress = this.tenant.contactAddress;
        this.tenantAddress = { ...this.tenant.contactAddress };
        this.tenant.contactAddress = null;
      });
  }

  openModalAddress() {
    this.addressModalShow = true;
  }

  updateAddress() {
    if (
      _.isNil(this.tenantAddress) ||
      Util.addressDiff(this.tenantAddress, this.selectedAddress)
    ) {
      this.tenant.contactAddress = this.selectedAddress;
    } else {
      this.tenant.contactAddress = null;
    }
  }

  //Config
  searchEmployeesOfWarehouseConfig_OnPress = _.debounce(
    this.searchEmployeesOfWarehouseConfig,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );

  async searchEmployeesOfWarehouseConfig(keyword) {
    if (
      Util.isEmpty(keyword) ||
      keyword.length < AppConsts.keyWordAtleastLength
    )
      return;
    this.objectLoading = true;
    const request = {
      tenantId: this.$store.state.tenant.editTenant.id,
      keyword,
    };
    await this.$store
      .dispatch({
        type: "user/searchEmployeesOfWarehouse",
        data: request,
      })
      .then((res) => {
        this.objectLoading = false;
        this.employeesConfig = res;
      });
  }

  changeEmployeeConfig(id) {
    this.employeeConfig = _.find(this.employeesConfig, function (obj) {
      if (obj.id === id) {
        return true;
      }
    });
  }

  changeNotificationTypeConfig(id) {
    this.notificationTypeConfig = _.find(
      this.notificationTypes,
      function (obj) {
        if (obj.id === id) return true;
      }
    );
  }

  async onAddNewConfig() {
    if (!this.modeAddConfig) {
      this.modeAddConfig = true;
      this.listConfig = [];
    }

    if (this.employeeIdConfig === 0 || this.notificationTypeCodeConfig === "")
      return;

    const userId = this.employeeIdConfig;
    const type = this.notificationTypeCodeConfig;
    const eixtConfig = _.find(this.listConfig, function (obj) {
      if (
        obj.object.toString() === userId.toString() &&
        obj.notificationTypecode === type
      )
        return obj;
    });
    if (!_.isNil(eixtConfig) && !_.isEmpty(eixtConfig)) {
      this.$Message.error("Cấu hình thông báo đối tượng trên đã tồn tại");
      return;
    }

    await this.$store
      .dispatch({
        type: "tenant/checkNotificationConfigExisted",
        data: {
          warehouseCode: this.tenant.tenancyName,
          object: this.employeeIdConfig,
          objectType: "USER",
          NotificationTypecode: this.notificationTypeCodeConfig,
        },
      })
      .then((res) => {
        if (res) {
          this.$Message.error("Cấu hình thông báo đối tượng trên đã tồn tại");
          return;
        }
        const newConfig = {
          id: 0,
          warehouseCode: this.tenant.tenancyName,
          object: this.employeeConfig.id,
          objectType: "USER",
          notificationTypecode: this.notificationTypeConfig.id,
          objectName: `${this.employeeConfig.userName} - ${this.employeeConfig.name}`,
          notificationTypeName: this.notificationTypeConfig.name,
        };

        this.listConfig.unshift(newConfig);
      });
  }

  async onDeleteConfig(id: number, index: number) {
    if (id === 0) {
      this.listConfig.splice(index, 1);
    } else {
      this.$Modal.confirm({
        title: "Xác nhận xóa cấu hình thông báo đã lưu",
        content: "Xóa cấu hình thông báo đã lưu",
        okText: Util.getYesText(),
        cancelText: Util.getNoText(),
        onOk: async () => {
          await this.$store
            .dispatch({
              type: "tenant/deleteNotificationConfig",
              data: {
                id,
              },
            })
            .then((res) => {
              if (res) this.listConfig.splice(index, 1);
            });
        },
      });
    }
  }
  async onDeleteAllConfig() {
    if (this.modeAddConfig) {
      this.listConfig = [];
      return;
    } else {
      this.$Modal.confirm({
        title: "Xác nhận xóa tất cả cấu hình thông báo đã lưu",
        content: "Xóa tất cả cấu hình thông báo đã lưu",
        okText: Util.getYesText(),
        cancelText: Util.getNoText(),
        onOk: async () => {
          await this.$store
            .dispatch({
              type: "tenant/deleteAllNotificationConfig",
              data: {
                warehouseCode: this.tenant.tenancyName,
              },
            })
            .then((res) => {
              if (res) this.listConfig = [];
            });
        },
      });
    }
  }

  //Filter
  searchEmployeesOfWarehouse_OnPress = _.debounce(
    this.searchEmployeesOfWarehouse,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );

  async searchEmployeesOfWarehouse(keyword) {
    if (
      Util.isEmpty(keyword) ||
      keyword.length < AppConsts.keyWordAtleastLength
    )
      return;
    this.objectLoading = true;
    const request = {
      tenantId: this.$store.state.tenant.editTenant.id,
      keyword,
    };
    await this.$store
      .dispatch({
        type: "user/searchEmployeesOfWarehouse",
        data: request,
      })
      .then((res) => {
        this.objectLoading = false;
        this.employeesFilter = res;
      });
  }

  async searchNotificationConfig() {
    this.modeAddConfig = false;
    var objectFilter =
      _.isNil(this.employeeIdFilter) || this.employeeIdFilter <= 0
        ? null
        : this.employeeIdFilter;
    const request = {
      maxResultCount: this.pageSizeConfig,
      skipCount: (this.currentPageConfig - 1) * this.pageSizeConfig,
      warehouseCode: this.tenant.tenancyName,
      object: objectFilter,
      notificationTypecode: this.notificationTypeCodeFilter,
    };
    await this.$store
      .dispatch({
        type: "tenant/searchNotificationConfigs",
        data: request,
      })
      .then(() => {
        this.listConfig = this.$store.state.tenant.listConfig;
      });
  }

  pageChangeConfig(page: number) {
    this.$store.commit("tenant/setCurrentPageConfig", page);
    this.searchNotificationConfig();
  }
  pagesizeChangeConfig(pagesize: number) {
    this.$store.commit("tenant/setPageSizeConfig", pagesize);
    this.searchNotificationConfig();
  }

  get pageSizeConfig() {
    return this.$store.state.tenant.pageSizeConfig;
  }
  get totalCountConfig() {
    return this.$store.state.tenant.totalCountConfig;
  }
  get currentPageConfig() {
    return this.$store.state.tenant.currentPageConfig;
  }

  get loading() {
    return this.$store.state.tenant.loading;
  }

  columnsConfig = [
    {
      title: this.L("Order"),
      width: 70,
      slot: "order",
    },
    {
      title: this.L("Employee"),
      key: "objectName",
    },
    {
      title: "Đối tượng",
      key: "notificationTypeName",
    },
    {
      title: this.L("Action"),
      slot: "action",
      renderHeader: (h: any, params: any) => {
        return h("div", [
          h("span", Util.L("Action")),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
                class: "ivu-icon",
              },
              style: {
                marginRight: "5px",
                marginLeft: "5px",
              },
              on: {
                click: () => {
                  this.onDeleteAllConfig();
                },
              },
            },
            "Xóa tất cả"
          ),
        ]);
      },
    },
  ];

  async created() {
    await this.$store
      .dispatch({
        type: "ref/getRefsForSelect",
        param: {
          tableName: AppConsts.tableRef.tableWh.name,
          columnName: AppConsts.tableRef.tableWh.column.inboundMode,
        },
      })
      .then((res) => {
        this.getInboundModes(res);
      });
    await this.$store
      .dispatch({
        type: "masterData/getNotificationTypes",
      })
      .then((res) => {
        this.getNotificationType(res);
      });
  }

  tenantRule = {
    tenancyName: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("TenancyName")
        ),
        trigger: "blur",
      },
    ],
    contactPhone: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("ContactPhone")
        ),
        trigger: "blur",
      },
    ],
    adminEmailAddress: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("AdminEmailAddress")
        ),
        trigger: "blur",
      },
    ],
    inboundMode: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("InboundMode")
        ),
        trigger: "blur",
      },
    ],
  };
}
